<template>
  <nav class="navbar is-spaced" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <router-link to="/">
        <h1 class="navbar-item"
          >📡
          <span class="is-size-3 ml-4">Nostr</span></h1>
      </router-link>
      <a
        role="button"
        class="navbar-burger"
        aria-label="menu"
        aria-expanded="false"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
    <div class="navbar-menu">
      <div class="navbar-end">
        <div class="navbar-item">
          <form class="field has-addons" @submit="submitSearch">
            <div class="control">
              <input class="input" v-model="search" placeholder="Search..." />
            </div>
            <div class="control">
              <button class="button">Go</button>
            </div>
          </form>
        </div>
        <!-- <div class="navbar-item">
          <router-link to="/setup">Setup</router-link>
        </div> -->
        <div class="navbar-item">
          <a
            :href="'#/' + $store.getters.pubKeyHex"
            :title="$store.getters.pubKeyHex"
          >
            <figure class="image">
              <img
                class="is-rounded"
                src="https://bulma.io/images/placeholders/128x128.png"
              />
            </figure>
          </a>
        </div>
      </div>
    </div>
  </nav>
  <div>
    <router-view />
  </div>
</template>

<script>
  export default {
    data() {
      return { search: "" };
    },
    methods: {
      submitSearch(e) {
        e.preventDefault();
        this.$router.push("/" + this.search);
        this.search = "";
      }
    }
  };
</script>
